<template>
  <form name="retailmade" method="POST" netlify data-netlify-honeypot="bot-field">
    <input type="hidden" name="form-name" :value="(formname)" />
    <div v-for="(inputfield, index) in inputfields">
      <input :type="(inputfield.type)" id="name" :name="(inputfield.title)" :placeholder="(inputfield.title)"/>
    </div>
    <button type="submit">Versturen</button>
  </form>
</template>

<script>
import { deliveryClient } from '@/kontent.js'

  export default {
    name: 'contactform',
    data: function() {
      return {
        inputfields: []
      }
    },
    props: {
      formname: String
    },
    created: function(){
      var query = deliveryClient
      .items()
      .type('form')
      .depthParameter(1)
      .toObservable()
      .toPromise()
      .then(response => {
        this.$data.inputfields = response.items[0].untitled_linked_items.value.map(item => ({
          title: item.placeholder.value,
          type: item.type.value[0].name
        }))
      })
    }
  }
</script>
